// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"bf57c671","371":"41e0c6bc"}[chunkId] + ".chunk.js";
};